/**
 * Created by fabian.forster on 16.02.2017.
 */
ixModuleRouting("impactx.deliverycomplaint", {
    "/deliverycomplaintlist": {
        template: "<ixa-deliverycomplaint-list></ixa-deliverycomplaint-list>",
        templateUrl: "modules/deliverycomplaint/templates/deliverycomplaintlist.html",
        process: "DeliveryComplaint",
        controller: "DeliveryComplaintListCtrl",
        controllerAs: "deliveryComplaintListCtrl",
        workspace: "shop",
    },
    "/deliverycomplaintlist/:id": {
        template: "<ixa-deliverycomplaint-list></ixa-deliverycomplaint-list>",
        templateUrl:
            "modules/deliverycomplaint/templates/deliverycomplaintlist.html",
        process: "DeliveryComplaint",
        controller: "DeliveryComplaintListCtrl",
        controllerAs: "deliveryComplaintListCtrl",
        workspace: "shop",
    },
    "/deliverycomplaint/:id": {
        template: "<ixa-delivery-complaint-detail></ixa-delivery-complaint-detail>",
        templateUrl: "modules/deliverycomplaint/templates/deliverycomplaint.html",
        process: "ViewDeliveryComplaint",
        controller: "DeliveryComplaintCtrl",
        controllerAs: "deliveryComplaintCtrl",
        workspace: "shop",
    },
    "/deliverycomplaint/:id/:dnhid": {
        template: "<ixa-delivery-complaint-detail></ixa-delivery-complaint-detail>",
        templateUrl:
            "modules/deliverycomplaint/templates/deliverycomplaint.html",
        process: "ViewDeliveryComplaint",
        controller: "DeliveryComplaintCtrl",
        controllerAs: "deliveryComplaintCtrl",
        workspace: "shop",
    },
    "/deliverycomplaint/:id/:dnhid/:pohid": {
        template: "<ixa-delivery-complaint-detail></ixa-delivery-complaint-detail>",
        templateUrl:
            "modules/deliverycomplaint/templates/deliverycomplaint.html",
        process: "ViewDeliveryComplaint",
        controller: "DeliveryComplaintCtrl",
        controllerAs: "deliveryComplaintCtrl",
        workspace: "shop",
    },
    "/deliverycomplaint/:id/:dnhid/:pohid/:doCheck": {
        template: "<ixa-delivery-complaint-detail></ixa-delivery-complaint-detail>",
        templateUrl:
            "modules/deliverycomplaint/templates/deliverycomplaint.html",
        process: "ViewDeliveryComplaint",
        controller: "DeliveryComplaintCtrl",
        controllerAs: "deliveryComplaintCtrl",
        workspace: "shop",
    },
    "/deliverycomplaint/:id/:dnhid/:pohid/:doCheck/:acceptedPartialDelivery/:acceptedOvershipment/:needsAllItems":
        {
            template: "<ixa-delivery-complaint-detail></ixa-delivery-complaint-detail>",
            templateUrl:
                "modules/deliverycomplaint/templates/deliverycomplaint.html",
            process: "ViewDeliveryComplaint",
            controller: "DeliveryComplaintCtrl",
            controllerAs: "deliveryComplaintCtrl",
            workspace: "shop",
        },
    "/simplecomplaint/:pohId/:dnhId?": {
        template: "<ixa-simple-complaint></ixa-simple-complaint>",
        templateUrl:
            "modules/deliverycomplaint/templates/simplecomplaint.tmpl.html",
        process: "ViewDeliveryComplaint",
        controller: "SimpleComplaintCtrl",
        controllerAs: "simpleComplaintCtrl",
        workspace: "shop",
    },
});
